import React from 'react';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
import { TableCell } from '../Carbon';
/**
 * React Component
 *
 * The AsperaCellText provides the column data for regular text with secondaryText
 *
 * @example
 * ```javascript
 * <AsperaCellText text={'My text'} secondaryText={'My secondary text'} />
 * ```
 */
class AsperaCellText extends React.Component {
    constructor() {
        super(...arguments);
        this.row = undefined;
        this.subManager = new SubManager();
    }
    componentDidMount() {
        const { forceUpdater } = this.props;
        this.subManager.setSubscription(forceUpdater.subscribe({
            next: data => {
                const { rowId } = this.props;
                if (data.id === rowId) {
                    this.row = data.row;
                    this.setState({});
                }
                else if (data.id === 'ASPERA_TABLE_UPDATE') {
                    const { row } = this.props;
                    this.row = row;
                    this.setState({});
                }
            },
            error: error => {
                new AsperaError('AsperaCellText: Unable to subscribe to force updater for row updates', error);
            },
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { className, handleClick, header, getTableText, row, overrideTitle } = this.props;
        if (!this.row)
            this.row = row;
        const text = getTableText(this.row, header.key, header.formatter);
        const secondaryText = header.secondaryKey ? getTableText(this.row, header.secondaryKey, header.secondaryFormatter) : undefined;
        return (React.createElement(TableCell, { className: `aspera-cell-text ${secondaryText ? 'has-secondary-text' : ''} ${header.allowOverflow ? '' : 'clip-content'} ${className ? className : ''}`, onClick: () => {
                handleClick(this.row);
            }, "data-auto": "table-cell-text" },
            React.createElement("span", { title: overrideTitle || text, className: "primary-text" }, text),
            !!secondaryText && React.createElement("span", { title: overrideTitle || secondaryText, className: "secondary-text" }, secondaryText)));
    }
}
export default AsperaCellText;
